import { IAuthenticatedUserInfo, isMsa } from '@notes/webintegrations-common'
import { renderO365Shell } from './o365Shell'
import { renderReactShell } from './reactShell'

export async function applyShell(onSignOut: () => void, onSettingsClick: () => void, userInfo: IAuthenticatedUserInfo | undefined): Promise<void> {
  if (!userInfo) {
    // If we don't have user information, we won't be able to show the header. This can happen because we are
    // debugging locally or because we ran into some sort of issue when retrieving credentials
    return
  }

  if (isMsa(userInfo.authType)) {
    await renderReactShell(onSignOut, onSettingsClick, userInfo)
    return
  }

  await renderO365Shell(onSignOut, onSettingsClick, userInfo)
}
